
export default function TechArchitecture() {
  const layers = [
    {
      title: '数据源层',
      items: ['平台', '收款', '报关', '单证'],
      icon: 'ri-database-2-line',
      color: 'bg-[#F0FDFA] border-[#14B8A6]/20',
      iconColor: 'text-[#14B8A6] bg-[#14B8A6]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
    {
      title: '数据结构化引擎',
      items: ['字段映射', '格式标准化', '关系建模'],
      icon: 'ri-settings-3-line',
      color: 'bg-[#FFF7ED] border-orange-200',
      iconColor: 'text-[#FF6B35] bg-[#FF6B35]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
    {
      title: '规则校验层',
      items: ['字段校验', '逻辑校验', '差异识别'],
      icon: 'ri-shield-check-line',
      color: 'bg-[#F0FDFA] border-[#14B8A6]/20',
      iconColor: 'text-[#14B8A6] bg-[#14B8A6]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
    {
      title: '链路管理模型',
      items: ['三流对齐', '版本控制', '关系追溯'],
      icon: 'ri-links-line',
      color: 'bg-[#FFF7ED] border-orange-200',
      iconColor: 'text-[#FF6B35] bg-[#FF6B35]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
    {
      title: '归档与留痕层',
      items: ['版本记录', '操作日志', '目录结构'],
      icon: 'ri-archive-line',
      color: 'bg-[#F0FDFA] border-[#14B8A6]/20',
      iconColor: 'text-[#14B8A6] bg-[#14B8A6]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
    {
      title: '服务增强层',
      items: ['退税', '核算', '值守'],
      icon: 'ri-stack-line',
      color: 'bg-[#FFF7ED] border-orange-200',
      iconColor: 'text-[#FF6B35] bg-[#FF6B35]/10',
      tagColor: 'bg-white border-gray-200 text-gray-600',
    },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-[#F0FDFA] via-white to-[#FFF7ED]">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-4">
          星贸云技术架构
        </h2>
        <p className="text-center text-gray-500 mb-16 max-w-[700px] mx-auto">
          我们以规则引擎与结构化模型为核心，
          将出口业务从"操作行为"转变为"数据关系管理"。
        </p>

        <div className="space-y-4">
          {layers.map((layer, index) => (
            <div key={index}>
              <div className={`relative p-6 rounded-xl border ${layer.color} hover:shadow-md transition-all group`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${layer.iconColor} flex-shrink-0`}>
                      <i className={`${layer.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-gray-800">{layer.title}</h3>
                  </div>
                  <div className="flex items-center gap-2">
                    {layer.items.map((item, i) => (
                      <span
                        key={i}
                        className={`px-3 py-1 text-xs rounded-full border ${layer.tagColor}`}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {index < layers.length - 1 && (
                <div className="flex justify-center py-2">
                  <div className="w-px h-6 bg-gradient-to-b from-[#14B8A6] to-[#14B8A6]/20"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
